import { toast } from 'sonner';

import { AccountFormSheet } from '../accounts/AccountFormSheet';
import { useAssetSheet } from '../../features/quickCreate/SheetProviders';
import { useCreateAccountMutation } from '../../features/accounts/queries';
import pt from '../../locales/pt';

export function QuickAssetSheet() {
  const { isOpen, close } = useAssetSheet();
  const createAccount = useCreateAccountMutation();

  const onSubmit = async (payload) => {
    try {
      await createAccount.mutateAsync(payload);
      toast.success(pt.quickCreate.asset.createdToast);
      close();
    } catch (err) {
      const message =
        typeof err === 'string'
          ? err
          : err?.detail || (Array.isArray(err) ? err.join(' ') : null) || JSON.stringify(err);
      toast.error(message);
    }
  };

  return (
    <AccountFormSheet
      isOpen={isOpen}
      onClose={close}
      onSubmit={onSubmit}
      initialValues={null}
      isPending={createAccount.isPending}
    />
  );
}
